<div class="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center p-4">
  <div class="w-full max-w-md">
    
    <!-- Header dinámico -->
    <div class="text-center mb-8">
      <div class="mx-auto w-200 h-20 bg-gradient-to-b from-gray-900 to-gray-800 rounded-2xl flex items-center justify-center shadow-2xl mb-4">
        <img src="../../../assets/img/logo.png" alt="Logo" class="h-10 w-auto max-w-[200px] object-contain" />
      </div>
      
      <!-- Título dinámico según el paso -->
      <ng-container [ngSwitch]="currentStep">
        <div *ngSwitchCase="'login'">
          <h2 class="text-xl font-semibold text-gray-900 mb-2">Bienvenido</h2>
          <p class="text-gray-600">Accede a tu cuenta para continuar</p>
        </div>
        <div *ngSwitchCase="'forgot-password'">
          <h2 class="text-xl font-semibold text-gray-900 mb-2">Recuperar Contraseña</h2>
          <p class="text-gray-600">Ingresa tu email para recibir un código de verificación</p>
        </div>
        <div *ngSwitchCase="'verify-otp'">
          <h2 class="text-xl font-semibold text-gray-900 mb-2">Verificar Código</h2>
          <p class="text-gray-600">Ingresa el código de 6 dígitos enviado a <span class="font-medium">{{ recoveryEmail }}</span></p>
        </div>
        <div *ngSwitchCase="'reset-password'">
          <h2 class="text-xl font-semibold text-gray-900 mb-2">Nueva Contraseña</h2>
          <p class="text-gray-600">Establece tu nueva contraseña</p>
        </div>
      </ng-container>
    </div>

    <!-- Contenedor principal de formularios -->
    <div class="bg-white rounded-2xl shadow-xl p-8">
      
      <!-- ==================== FORMULARIO DE LOGIN ==================== -->
      <div *ngIf="currentStep === 'login'">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-6">
          <!-- Campo email -->
          <div>
            <label for="email" class="block text-sm font-semibold text-gray-700 mb-2">
              Correo Electrónico <span class="text-red-500">*</span>
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </div>
              <input 
                type="email" 
                id="email"
                formControlName="email"
                class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out sm:text-sm"
                placeholder="Correo electrónico"
                [class.border-red-300]="hasFieldError('email')"
                [class.focus:ring-red-500]="hasFieldError('email')"
                [class.focus:border-red-500]="hasFieldError('email')"
                [class.border-green-300]="email?.valid && email?.touched"
                [class.focus:ring-green-500]="email?.valid && email?.touched"
                [class.focus:border-green-500]="email?.valid && email?.touched">
            </div>
            <div *ngIf="hasFieldError('email')" class="mt-1 text-sm text-red-600">
              {{ getFieldError('email') }}
            </div>
          </div>

          <!-- Campo contraseña -->
          <div>
            <label for="password" class="block text-sm font-semibold text-gray-700 mb-2">
              Contraseña <span class="text-red-500">*</span>
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
                </svg>
              </div>
              <input 
                [type]="showPassword ? 'text' : 'password'" 
                id="password"
                formControlName="password"
                class="block w-full pl-10 pr-12 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out sm:text-sm"
                placeholder="Contraseña"
                [class.border-red-300]="hasFieldError('password')"
                [class.focus:ring-red-500]="hasFieldError('password')"
                [class.focus:border-red-500]="hasFieldError('password')"
                [class.border-green-300]="password?.valid && password?.touched"
                [class.focus:ring-green-500]="password?.valid && password?.touched"
                [class.focus:border-green-500]="password?.valid && password?.touched">
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
                <button 
                  type="button" 
                  (click)="togglePasswordVisibility()"
                  class="text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600 transition duration-150 ease-in-out"
                  tabindex="-1">
                  <svg *ngIf="!showPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  <svg *ngIf="showPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                  </svg>
                </button>
              </div>
            </div>
            <div *ngIf="hasFieldError('password')" class="mt-1 text-sm text-red-600">
              {{ getFieldError('password') }}
            </div>
          </div>        

          <!-- Enlace para recuperación de contraseña -->
          <div class="text-center">
            <button 
              type="button"
              (click)="goToForgotPassword()"
              class="text-sm text-blue-600 hover:text-blue-800 transition duration-150 ease-in-out">
              ¿Olvidaste tu contraseña?
            </button>
          </div>

          <!-- Botón de submit -->
          <div>
            <button 
              type="submit" 
              [disabled]="!loginForm.valid || isLoading"
              class="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-xl text-white bg-gradient-to-b from-gray-900 to-gray-800 hover:from-blue-700 hover:to-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out transform hover:scale-105 shadow-lg">
              <span *ngIf="!isLoading" class="flex items-center">
                <svg class="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                </svg>
                Iniciar Sesión
              </span>
              <span *ngIf="isLoading" class="flex items-center">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Iniciando sesión...
              </span>
            </button>
          </div>
        </form>
      </div>

      <!-- ==================== FORMULARIO FORGOT PASSWORD ==================== -->
      <div *ngIf="currentStep === 'forgot-password'">
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmitForgotPassword()" class="space-y-6">
          <!-- Campo email -->
          <div>
            <label for="forgotEmail" class="block text-sm font-semibold text-gray-700 mb-2">
              Correo Electrónico <span class="text-red-500">*</span>
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </div>
              <input 
                type="email" 
                id="forgotEmail"
                formControlName="email"
                class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out sm:text-sm"
                placeholder="tu-email@ejemplo.com"
                [class.border-red-300]="hasRecoveryFieldError('email', 'forgot')"
                [class.focus:ring-red-500]="hasRecoveryFieldError('email', 'forgot')"
                [class.focus:border-red-500]="hasRecoveryFieldError('email', 'forgot')"
                [class.border-green-300]="forgotPasswordEmail?.valid && forgotPasswordEmail?.touched"
                [class.focus:ring-green-500]="forgotPasswordEmail?.valid && forgotPasswordEmail?.touched"
                [class.focus:border-green-500]="forgotPasswordEmail?.valid && forgotPasswordEmail?.touched">
            </div>
            <div *ngIf="hasRecoveryFieldError('email', 'forgot')" class="mt-1 text-sm text-red-600">
              {{ getRecoveryFieldError('email', 'forgot') }}
            </div>
          </div>

          <!-- Botones -->
          <div class="flex space-x-3">
            <button 
              type="button"
              (click)="backToLogin()"
              class="flex-1 py-3 px-4 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out">
              Volver al Login
            </button>
            
            <button 
              type="submit" 
              [disabled]="!forgotPasswordForm.valid || isSendingOtp"
              class="flex-1 py-3 px-4 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out">
              <span *ngIf="!isSendingOtp" class="flex items-center justify-center">
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                Enviar Código
              </span>
              <span *ngIf="isSendingOtp" class="flex items-center justify-center">
                <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Enviando...
              </span>
            </button>
          </div>
        </form>
      </div>

      <!-- ==================== FORMULARIO VERIFY OTP ==================== -->
      <div *ngIf="currentStep === 'verify-otp'">
        <form [formGroup]="verifyOtpForm" (ngSubmit)="onSubmitVerifyOtp()" class="space-y-6">
          <!-- Campo OTP -->
          <div>
            <label for="otpCode" class="block text-sm font-semibold text-gray-700 mb-2">
              Código de Verificación <span class="text-red-500">*</span>
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
                </svg>
              </div>
              <input 
                type="text" 
                id="otpCode"
                formControlName="otpCode"
                maxlength="6"
                class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out sm:text-sm text-center text-lg tracking-widest"
                placeholder="123456"
                [class.border-red-300]="hasRecoveryFieldError('otpCode', 'otp')"
                [class.focus:ring-red-500]="hasRecoveryFieldError('otpCode', 'otp')"
                [class.focus:border-red-500]="hasRecoveryFieldError('otpCode', 'otp')"
                [class.border-green-300]="otpCode?.valid && otpCode?.touched"
                [class.focus:ring-green-500]="otpCode?.valid && otpCode?.touched"
                [class.focus:border-green-500]="otpCode?.valid && otpCode?.touched">
            </div>
            <div *ngIf="hasRecoveryFieldError('otpCode', 'otp')" class="mt-1 text-sm text-red-600">
              {{ getRecoveryFieldError('otpCode', 'otp') }}
            </div>
            <p class="mt-1 text-xs text-gray-500">Ingresa el código de 6 dígitos que recibiste por correo</p>
          </div>

          <!-- Enlace para reenviar OTP -->
          <div class="text-center">
            <button 
              type="button"
              (click)="resendOtp()"
              [disabled]="otpResendCountdown > 0 || isSendingOtp"
              class="text-sm text-blue-600 hover:text-blue-800 disabled:text-gray-400 disabled:cursor-not-allowed transition duration-150 ease-in-out">
              <span *ngIf="otpResendCountdown === 0 && !isSendingOtp">¿No recibiste el código? Reenviar</span>
              <span *ngIf="otpResendCountdown > 0">Reenviar en {{ otpResendCountdown }}s</span>
              <span *ngIf="isSendingOtp">Reenviando...</span>
            </button>
          </div>

          <!-- Botones -->
          <div class="flex space-x-3">
            <button 
              type="button"
              (click)="backToLogin()"
              class="flex-1 py-3 px-4 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out">
              Cancelar
            </button>
            
            <button 
              type="submit" 
              [disabled]="!verifyOtpForm.valid || isVerifyingOtp"
              class="flex-1 py-3 px-4 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out">
              <span *ngIf="!isVerifyingOtp" class="flex items-center justify-center">
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Verificar Código
              </span>
              <span *ngIf="isVerifyingOtp" class="flex items-center justify-center">
                <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Verificando...
              </span>
            </button>
          </div>
        </form>
      </div>

      <!-- ==================== FORMULARIO RESET PASSWORD ==================== -->
      <div *ngIf="currentStep === 'reset-password'">
        <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmitResetPassword()" class="space-y-6">
          <!-- Nueva contraseña -->
          <div>
            <label for="newPassword" class="block text-sm font-semibold text-gray-700 mb-2">
              Nueva Contraseña <span class="text-red-500">*</span>
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
                </svg>
              </div>
              <input 
                [type]="showNewPassword ? 'text' : 'password'" 
                id="newPassword"
                formControlName="newPassword"
                class="block w-full pl-10 pr-12 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out sm:text-sm"
                placeholder="Tu nueva contraseña"
                [class.border-red-300]="hasRecoveryFieldError('newPassword', 'reset')"
                [class.focus:ring-red-500]="hasRecoveryFieldError('newPassword', 'reset')"
                [class.focus:border-red-500]="hasRecoveryFieldError('newPassword', 'reset')"
                [class.border-green-300]="newPassword?.valid && newPassword?.touched"
                [class.focus:ring-green-500]="newPassword?.valid && newPassword?.touched"
                [class.focus:border-green-500]="newPassword?.valid && newPassword?.touched">
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
                <button 
                  type="button" 
                  (click)="toggleNewPasswordVisibility()"
                  class="text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600 transition duration-150 ease-in-out"
                  tabindex="-1">
                  <svg *ngIf="!showNewPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  <svg *ngIf="showNewPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                  </svg>
                </button>
              </div>
            </div>
            <div *ngIf="hasRecoveryFieldError('newPassword', 'reset')" class="mt-1 text-sm text-red-600">
              {{ getRecoveryFieldError('newPassword', 'reset') }}
            </div>
            <div class="mt-1 text-xs text-gray-500">
              <p class="font-medium mb-1">La contraseña debe cumplir:</p>
              <ul class="list-disc list-inside space-y-0.5">
                <li>Mínimo 6 caracteres</li>
                <li>Al menos una letra mayúscula (A-Z)</li>
                <li>Al menos un carácter especial (!&#64;#$%^&*)</li>
              </ul>
            </div>
          </div>

          <!-- Confirmar contraseña -->
          <div>
            <label for="confirmPassword" class="block text-sm font-semibold text-gray-700 mb-2">
              Confirmar Contraseña <span class="text-red-500">*</span>
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
                </svg>
              </div>
              <input 
                [type]="showConfirmPassword ? 'text' : 'password'" 
                id="confirmPassword"
                formControlName="confirmPassword"
                class="block w-full pl-10 pr-12 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out sm:text-sm"
                placeholder="Confirma tu nueva contraseña"
                [class.border-red-300]="hasRecoveryFieldError('confirmPassword', 'reset')"
                [class.focus:ring-red-500]="hasRecoveryFieldError('confirmPassword', 'reset')"
                [class.focus:border-red-500]="hasRecoveryFieldError('confirmPassword', 'reset')"
                [class.border-green-300]="confirmPassword?.valid && confirmPassword?.touched"
                [class.focus:ring-green-500]="confirmPassword?.valid && confirmPassword?.touched"
                [class.focus:border-green-500]="confirmPassword?.valid && confirmPassword?.touched">
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
                <button 
                  type="button" 
                  (click)="toggleConfirmPasswordVisibility()"
                  class="text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600 transition duration-150 ease-in-out"
                  tabindex="-1">
                  <svg *ngIf="!showConfirmPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  <svg *ngIf="showConfirmPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                  </svg>
                </button>
              </div>
            </div>
            <div *ngIf="hasRecoveryFieldError('confirmPassword', 'reset')" class="mt-1 text-sm text-red-600">
              {{ getRecoveryFieldError('confirmPassword', 'reset') }}
            </div>
          </div>

          <!-- Botones -->
          <div class="flex space-x-3">
            <button 
              type="button"
              (click)="backToLogin()"
              class="flex-1 py-3 px-4 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out">
              Cancelar
            </button>
            
            <button 
              type="submit" 
              [disabled]="!resetPasswordForm.valid || isResettingPassword"
              class="flex-1 py-3 px-4 border border-transparent text-sm font-medium rounded-xl text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out">
              <span *ngIf="!isResettingPassword" class="flex items-center justify-center">
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                Cambiar Contraseña
              </span>
              <span *ngIf="isResettingPassword" class="flex items-center justify-center">
                <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Cambiando...
              </span>
            </button>
          </div>
        </form>
      </div>
      
    </div>      

    <!-- Footer -->
    <div class="text-center mt-8">
      <p class="text-xs text-gray-500">
        © 2025 Sistema Financiero. Todos los derechos reservados.
      </p>
    </div>
  </div>
</div>
  